import {Room, RoomMember} from 'matrix-js-sdk';

export const getOtherMembers = (room: Room): RoomMember[] => {
  const membersExceptMe = room
    .getMembers()
    .filter((member) => member.userId !== room.client.getUserId());
  return membersExceptMe;
};
